import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automatePreSalesQualificationAr: TemplateAr = {
  name: 'أتمتة تأهيل ما قبل البيع بالذكاء الاصطناعي',
  description:
    'أهّل العملاء المحتملين الواردين تلقائياً بجمع المعلومات الأساسية وتقييم مدى الملاءمة وتوجيه الفرص الساخنة لفريق المبيعات.',
  category: 'المبيعات والتواصل',
  workflow: [
    { icon: MessageSquare, label: 'استفسار محتمل' },
    { icon: Sparkles, label: 'الـ AI يؤهّل' },
    { icon: Users, label: 'توجيه للمبيعات', final: true },
  ],
  detailDescription: {
    paragraph1:
      'أهّل كل عميل محتمل يجيك، مو بس اللي يفضى له أحد. الـ AI يسأل أسئلة التأهيل في محادثة طبيعية، ويقيّم حجم الشركة والميزانية والجدول الزمني ومدى الملاءمة لمنتجك، ويعطي كل عميل محتمل درجة حسب معاييرك أنت. الفرص الساخنة توصل للمبيعات مباشرة، والاستفسارات غير المؤهلة تتصفّى.',
    paragraph2:
      'الفرص المؤهلة توصل لـ CRM عندك بسياقها كامل — Salesforce أو HubSpot أو أي نظام تشغّله. ودرجات التأهيل وبياناته ونصوص المحادثات كلها تلقاها هناك عشان يراجعها فريق المبيعات. والـ AI يتعلّم من الصفقات المكسوبة عشان ترتفع دقة التأهيل.',
  },
  benefits: [
    'يأهّل العملاء المحتملين على مدار الساعة، بدون ما يتدخل فريق المبيعات',
    'كل عميل محتمل يتأهّل بنفس الأسئلة، كل مرة',
    'الفرص الساخنة توصل للمبيعات فوراً',
    'الاستفسارات غير المؤهلة تتصفّى',
    'فريق المبيعات يستلم سياق المحادثة كامل',
    'معدل التحويل من عميل محتمل لفرصة يرتفع',
  ],
};
